export const centerManagerUserFrag = `
    id
    titleBeforeName
    name
    surname
    titleAfterName
    email
`;
